import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { postNamedCommand, postNamedQuery } from '../service'
import { useAppContext } from '../redux/slices/appContext'

export const useGetGoals = (levelTypeId, { enabled = true } = {}) => {
  const { userId } = useAppContext()
  return useQuery({
    queryKey: ['get-goals-list', userId, levelTypeId ?? null],
    enabled,
    queryFn: async () => {
      const { data } = await postNamedQuery('levels', 'get-goals-list', {
        levelTypeId
      })
      return data
    }
  })
}
export const useCreateGoals = () => {
  const queryClient = useQueryClient()
  const { userId } = useAppContext()
  return useMutation({
    mutationFn: async ({ code, name, description, value, unit, startDate, endDate, levelTypeId }) => {
      const { data } = await postNamedCommand('levels', 'create-goal', {
        code,
        name,
        description,
        value,
        unit,
        startDate,
        endDate,
        ...(levelTypeId != null && { levelTypeId })
      })

      return data
    },
    onSuccess: (_data, variables) => {
      const levelTypeId = variables?.levelTypeId
      queryClient.invalidateQueries({
        queryKey: ['get-goals-list', userId, levelTypeId ?? null],
        refetchType: 'all'
      }).catch(console.error)
    }
  })
}

export const useModifyGoals = () => {
  const queryClient = useQueryClient()
  const { userId } = useAppContext()
  return useMutation({
    mutationFn: async (command) => {
      const { data } = await postNamedCommand('levels', 'modify-goal', command)
      return data
    },
    onSuccess: (_data, variables) => {
      const levelTypeId = variables?.levelTypeId
      queryClient.invalidateQueries({
        queryKey: ['get-goals-list', userId, levelTypeId ?? null],
        refetchType: 'all'
      }).catch(console.error)
    }
  })
}

export const useDeleteGoals = () => {
  const queryClient = useQueryClient()
  const { userId } = useAppContext()
  return useMutation({
    mutationFn: async (parameters) => {
      if (!parameters.deletedId) throw new Error('goalId is required')
      const { data } = await postNamedCommand('levels', 'remove-goal', { goalId: parameters.deletedId })
      return data
    },
    onSuccess: (_data, variables) => {
      const levelTypeId = variables?.levelTypeId
      queryClient.invalidateQueries({
        queryKey: ['get-goals-list', userId, levelTypeId ?? null],
        refetchType: 'all'
      }).catch(console.error)
    }
  })
}
